// Mock data for Rr Bros Bike Rental

export const siteInfo = {
  name: "Rr Bros Bike Rental",
  shortName: "RR Bros",
  phone: "070677 06719",
  phoneDisplay: "+91 70677 06719",
  email: "rrbros1695@gmail.com",
  checkPricesUrl: "/search",
  timings: {
    udupi: "Udupi Mon-Sun: 07:30 AM to 07:30 PM",
    manipal: "Manipal Mon-Sun: 09:00 AM to 07:30 PM",
  },
  tagline: "Your Bike When Need It Most",
  addressUdupi:
    "Karavali Junction, Karthik Trade Centre, Opp. New KSRTC Bus Stop, Udupi-576102",
  addressManipal:
    "Shambavi Soverign, Next to Country INN, End Pt. Road, Manipal",
};

export const navLinks = [
  { name: "Home", href: "/#home" },
  { name: "About", href: "/#about" },
  { name: "Scooters", href: "/#bikes" },
  { name: "Contact", href: "/#contact" },
  { name: "Terms & Conditions", href: "/terms" },
];

export const locations = [
  { id: "udupi", name: "Udupi" },
  { id: "manipal", name: "Manipal" },
];

export const rideTypes = [
  { id: "scooter", name: "Scooters" },
];

export const bikes = [
  {
    id: 1,
    name: "Honda Activa 6G",
    category: "scooter",
    image:
      "https://customer-assets-gfyr7b9c.emergentagent.net/job_bike-rental-hub-61/artifacts/72qa03sp_IMG_6127.png",
    mileage: "45 km/l",
    engine: "110cc",
    color: "Black",
  },
  {
    id: 2,
    name: "Yamaha Fascino 125",
    category: "scooter",
    image:
      "https://customer-assets-gfyr7b9c.emergentagent.net/job_bike-rental-hub-61/artifacts/wzmkb0kc_IMG_6126.png",
    mileage: "50 km/l",
    engine: "125cc",
    color: "Yellow",
  },
  {
    id: 3,
    name: "Yamaha Ray-Z",
    category: "scooter",
    image:
      "https://customer-assets-gfyr7b9c.emergentagent.net/job_bike-rental-hub-61/artifacts/jqns95si_IMG_6128.jpeg",
    mileage: "48 km/l",
    engine: "113cc",
    color: "Red",
  },
];

export const features = [
  {
    title: "Flexible Pricing",
    description:
      "One size never fits all. We provide flexible kilometer plans. Choose the plan that suits you best.",
    icon: "IndianRupee",
  },
  {
    title: "Well Maintained Fleet",
    description:
      "All scooters are owned by RR Bros and regularly maintained by authorized service centers for a safe ride.",
    icon: "Wrench",
  },
  {
    title: "Quick Pickup",
    description:
      "Simple paperwork and fast handover. Visit our branch, complete quick verification and ride out in minutes.",
    icon: "Zap",
  },
  {
    title: "On Time",
    description:
      "No waste of time during your holidays. Find a rental point in Udupi and Manipal, ready when you are.",
    icon: "Clock",
  },
];

export const galleryImages = [
  "https://images.unsplash.com/photo-1558981806-ec527fa84c39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxtb3RvcmN5Y2xlJTIwcm9hZHxlbnwwfHx8fDE3ODU4MDc2NDR8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1588756681780-9d5859fc2ca0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxtb3RvcmN5Y2xlJTIwcm9hZHxlbnwwfHx8fDE3ODU4MDc2NDR8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1558980664-769d59546b3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxtb3RvcmN5Y2xlJTIwcm9hZHxlbnwwfHx8fDE3ODU4MDc2NDR8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/17095636/pexels-photo-17095636.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/16330298/pexels-photo-16330298.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1624535478774-c7269849fec4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxiaWtlciUyMHJpZGluZ3xlbnwwfHx8fDE3ODU4MDc2Mzh8MA&ixlib=rb-4.1.0&q=85",
];

export const heroImage =
  "https://images.unsplash.com/photo-1519750292352-c9fc17322ed7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxzY29vdGVyJTIwcmlkaW5nfGVufDB8fHx8MTc4NTgxMjQ4M3ww&ixlib=rb-4.1.0&q=85";

export const testimonials = [
  {
    name: "Rahul Shetty",
    role: "Student, MIT Manipal",
    text: "Rented a Honda Activa 6G from RR Bros for a week. Scooter was in perfect condition and pricing was very affordable. Highly recommended for students!",
    rating: 5,
  },
  {
    name: "Priya Kamath",
    role: "Tourist",
    text: "Best scooter rental service in Udupi. The Yamaha Fascino 125 I rented was well maintained and the pickup was quick and easy. Great service.",
    rating: 5,
  },
  {
    name: "Ankit Sharma",
    role: "Traveler",
    text: "Explored the entire coastal Karnataka on the Yamaha Ray-Z I rented. Scooter performance and mileage were excellent. Will surely rent again.",
    rating: 5,
  },
];
